<template>
  <v-list-item-avatar tile v-on="{ ...$listeners }" v-if="!getHideIcons"
    ><slot v-bind="$attrs"></slot>
  </v-list-item-avatar>
</template>
<script>
import { defineComponent } from "vue";
import { getHideIcons } from "common/utils/icons.js";
export default defineComponent({
  name: "ListIcon",
  props: {},
  computed: {
    getHideIcons,
  },
});
</script>
